import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useAtomValue } from 'jotai';
import { metricSelector, selectedMetricSelector } from '@store/metricsChartContainer/selectors';
import { INVERTED_METRIC_SWITCH_MAP } from '@utils/metrics';
import { diagnosticsModeAtom } from '@components/metrics-panel-hz/atoms';
import { globalOrderBySelector } from '@store/trends/base/selectors';

function useExportMetrics() {
  const diagMode = useAtomValue(diagnosticsModeAtom);
  const selectedMetric = useSelector(selectedMetricSelector);
  const metrics = useSelector(metricSelector);
  const orderByMetric = useSelector(globalOrderBySelector);

  const exportMetrics = useMemo(() => {
    // list of visible metrics
    let baseMetrics = [...metrics];
    if (diagMode) {
      baseMetrics = [selectedMetric];
      if (selectedMetric !== orderByMetric) {
        baseMetrics.push(orderByMetric);
      }
    }

    const exportMetrics: string[] = [];
    baseMetrics.forEach((m) => {
      exportMetrics.push(m);
      if (m in INVERTED_METRIC_SWITCH_MAP) {
        exportMetrics.push(INVERTED_METRIC_SWITCH_MAP[m]);
      }
    });

    return exportMetrics;
  }, [selectedMetric, diagMode, metrics, orderByMetric]);

  return exportMetrics;
}

export default useExportMetrics;
